import React, { useState } from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpPlatformInvoiceSummaryItem from '../../../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceSummaryItem';
import TpPlatformInvoiceService from '../../../Services/TpPlatformInvoiceService';
import TpPlatformInvoiceCostSummarySearchParams from './TpPlatformInvoiceCostSummarySearchParams';
import TpPlatformInvoiceBravoJobsPopup from './TpPlatformInvoiceBravoJobsPopup';

// Embedded grid for the "Summarized Invoice Items" sub-tabs of the platform-invoice detail
// popup: the invoice's frozen PlatformCostSummary rows (matched by provenance source +
// platform invoice id), optionally scoped to one cost type. All scoping values are
// re-stamped on every search so the user cannot search their way out of the tab.
// Empty until the invoice is summarized — permanently for pre-cutoff/ignored invoices.
// A positive Bravo Shop Count on an Assignment row links to the per-client Bravo-jobs
// popup (nested OverWindow — the CD-5241 z-index escalation in Css/OverWindow.css keeps
// it above the parent detail popup's chrome).
const TpPlatformInvoiceCostSummaryTab = ({
  thirdPartySource = '',
  thirdPartyInvoiceId = '',
  costType = '',
  lineItemType = TpPlatformInvoiceSummaryItem,
}) => {
  const [searchItem, setSearchItem] = useState<any>(() => {
    const params = new (TpPlatformInvoiceCostSummarySearchParams as any)();
    params.ThirdPartySource = thirdPartySource;
    params.ThirdPartyInvoiceId = thirdPartyInvoiceId;
    params.CostType = costType;
    return params;
  });
  const [bravoJobsRow, setBravoJobsRow] = useState<any>(null);

  const startSearch = (newSearchItem: any) =>
    setSearchItem({
      ...newSearchItem,
      ThirdPartySource: thirdPartySource,
      ThirdPartyInvoiceId: thirdPartyInvoiceId,
      CostType: costType,
    });

  // TabbedPage mounts only the active sub-tab, so this render-time (re-)binding always
  // points the shared static at the tab instance that is actually on screen.
  TpPlatformInvoiceSummaryItem.showBravoJobsFunction = (row) => setBravoJobsRow(row);

  return (
    <>
      <TabOfDataTable
        type={lineItemType}
        serviceFunction={TpPlatformInvoiceService.GetCostSummariesBySearching}
        convertDBItemsFunction={TpPlatformInvoiceService.ConvertDBCostSummaryItems}
        searchItem={searchItem}
        searchParamsType={TpPlatformInvoiceCostSummarySearchParams}
        showSearchStrip={true}
        clickOnStartSearch={startSearch}
        popupEnabled={false}
        singleSearchLine={true}
        singleSearchLinePlaceholder={
          costType ? 'Search in office, client...' : 'Search in office, client, cost type...'
        }
        errorCode='TPPCS01'
        useClickOnClearAll={true}
      />
      {bravoJobsRow && (
        <TpPlatformInvoiceBravoJobsPopup
          title={`Bravo Jobs - ${bravoJobsRow.ClientName} (${bravoJobsRow.OfficeName})`}
          thirdPartySource={thirdPartySource}
          thirdPartyInvoiceId={thirdPartyInvoiceId}
          billingPeriod={bravoJobsRow.BillingPeriod}
          officeId={bravoJobsRow.OfficeId}
          clientId={bravoJobsRow.ClientId}
          clickOnCancel={() => setBravoJobsRow(null)}
        />
      )}
    </>
  );
};

export default TpPlatformInvoiceCostSummaryTab;
